import { useOrganizationAppSessions } from "@/api";
import { AnalyticsView } from "./AnalyticsView";

function LocalAnalytics() {
  return <AnalyticsView query={useOrganizationAppSessions} />;
}

export default LocalAnalytics;
